import Api from '../api/Api';
import resolve from  '../util/Configuracao';

class CalculoCoparticipacaoApi extends Api {
  async consultarDemonstrativosNaoPagos (numDemonstrativo) {
    let demonstrativos = [];
    try {
      const urlConsultarDemonstrativosNaoPagos = resolve('urlConsultarDemonstrativosNaoPagos') + numDemonstrativo;
      const { data } = await this.fetch(urlConsultarDemonstrativosNaoPagos);
      data.map(res => {
        const { numDemonstrativoPag, dtaEmissao, codPrestador, nomPrestador, cnpjPrestador, valTotalProcessado, valTotalLiberado, valTotalGlosado } = res;
        demonstrativos.push(Object.values({ numDemonstrativoPag, dtaEmissao, codPrestador, nomPrestador, cnpjPrestador, valTotalProcessado, valTotalLiberado, valTotalGlosado }));
      });
      return demonstrativos;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDemonstrativosNaoPagosOdonto (numDemonstrativo) {
    let demonstrativos = [];
    try {
      const urlConsultarDemonstrativosNaoPagosOdonto = resolve('urlConsultarDemonstrativosNaoPagosOdonto') + numDemonstrativo;
      const { data } = await this.fetch(urlConsultarDemonstrativosNaoPagosOdonto);
      data.map(res => {
        const { numDemonstrativoPag, dtaEmissao, codPrestador, nomPrestador, cnpjPrestador, valTotalProcessado, valTotalLiberado, valTotalGlosado } = res;
        demonstrativos.push(Object.values({ numDemonstrativoPag, dtaEmissao, codPrestador, nomPrestador, cnpjPrestador, valTotalProcessado, valTotalLiberado, valTotalGlosado }));
      });
      return demonstrativos;
    } catch (error) {
      console.error(error);
    }
  }

  async calcularCoparticipacao (numDemonstrativo, procedimentos) {
    try {
      const urlCalcularCoparticipacao = resolve('urlCalcularCoparticipacao') + numDemonstrativo;
      const response = await this.fetch(urlCalcularCoparticipacao, 'post', procedimentos);
      return response;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  async calcularCoparticipacaoOdonto (numDemonstrativo) {
    try {
      const urlCalcularCoparticipacaoOdonto = resolve('urlCalcularCoparticipacaoOdonto') + numDemonstrativo;
      const response = await this.fetch(urlCalcularCoparticipacaoOdonto, 'post');
      return response;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
  async getProcedimentos () {
    try {
      const urlConsultarTodosProcedimentos = resolve('urlConsultarTodosProcedimentos');
      const response = await this.fetch(urlConsultarTodosProcedimentos);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async getProcedimentosCaixa () {
    try {
      const urlConsultarTodosProcedimentosCaixa = resolve('urlConsultarTodosProcedimentosCaixa');
      const response = await this.fetch(urlConsultarTodosProcedimentosCaixa);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async lancarCoparticipacao () {
    try {
      const urlLancarCoparticipacao = resolve('urlLancarCoparticipacao');
      const response = await this.fetch(urlLancarCoparticipacao, 'get');
      return response;
    } catch (error) {
      console.error(error);
      return null;
    }
  }
}

export default CalculoCoparticipacaoApi;
